import React from "react";
import { connect } from "react-redux";
import { ReactComponent as QRScan } from "./qr-code.svg";
import QrReader from "react-qr-scanner";

function Index({ settings, language }) {
  return (
    <div
      style={{
        display: "grid",
        justifyItems: "center",
        alignItems: "center",
        height: "100vh",
        background: "white",
      }}
    >
      <div style={{ minWidth: 400 }}>
        <QRScan style={{ width: 150, height: 150, marginBottom: 20 }} />
        <p
          style={{
            fontWeight: "bold",
            maxWidth: 220,
            margin: "auto",
            direction: language === "arabic" ? "rtl" : "ltr",
          }}
        >
          {language === "arabic"
            ? "لبدء الطلب قم بمسح رمز QR"
            : "Scan QR code to start ordering"}
        </p>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    settings: state.store.store.settings,
    language: state.store.language,
  };
};
export default connect(mapStateToProps)(Index);
